import React, { useRef, useEffect } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';
import './whyCard.css';

const WhyCard = ({ icon, title, content, index }) => {
  const ref = useRef(null);
  const controls = useAnimation();
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const entranceTransforms = [
    { x: -100, y: -100, scale: 1.2, rotate: -15 },
    { x: 100, y: -120, scale: 1.3, rotate: 10 },
    { x: -150, y: 80, scale: 1.25, rotate: -8 },
    { x: 150, y: 60, scale: 1.2, rotate: 12 },
    { x: -120, y: -80, scale: 1.3, rotate: -10 },
    { x: 100, y: 100, scale: 1.15, rotate: 8 },
  ];

  const { x, y, scale, rotate } = entranceTransforms[index % entranceTransforms.length];

  useEffect(() => {
    if (isInView) {
      controls.start({
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
        rotate: 0,
        transition: {
          duration: 0.8,
          ease: 'easeOut',
          delay: index * 0.05,
        },
      });
    }
  }, [isInView, controls, x, y, scale, rotate, index]);

  return (
    <motion.div
      ref={ref}
      className="why-card"
      initial={{
        opacity: 0,
        x,
        y,
        scale,
        rotate,
      }}
      animate={isInView ? {
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
        rotate: 0,
        transition: {
          duration: 0.8,
          ease: 'easeOut',
          delay: index * 0.05,
        },
      } : {}}
      whileHover={{
        scale: 1.03,
        transition: { duration: 0.2 },
      }}
      whileTap={{
        scale: 0.98,
      }}
    >
      <img src={icon} className="why-icon" alt="icon" />
      <p className="why-title">{title}</p>
      <p className="why-content">{content}</p>
    </motion.div>
  );
};

export default WhyCard;
